window.console || (window.console = {
	log: function(){}
});
var KONOIKE = window.KONOIKE || null;
var cssua = window.cssua || null;

(function($) {
	const htmlHasClass = (_class) => {
		return $('html').hasClass(_class);
	};
	const siteName = '';
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const o = 'is-on';
	const slideSpeed = '400';

	KONOIKE = {
		va: {
			pathname: location.pathname,
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			},
			header: {
				desktop: 100,
				sp: 60
			}
		},
		localDecision() {
			var regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|9025\\.customer2\\.pronexus\\.co\\.jp)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() {
			let _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			let key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);
			let includeClassLen = includeClass.length;

			for (let i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (let i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done((...args) => {
					let regExp = new RegExp(key);

					if (args[1] === 'success') { // includeが1個だけの場合
						let position = $(args[0]).filter(':first').attr('class').split(' ');
						for (let j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(args[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					} else {
						for (let i = 0; i < args.length; i++) {
							let result = args[i];
							let position = $(result[0]).filter(':first').attr('class').split(' ');

							for (let j = 0; j < position.length; j++) {
								if (position[j].match(regExp)) {
									position = position[j];
									break;
								}
							}
							$('.' + position).html(result[0]).children().unwrap();

							console.log('Succeeded to read the include file!:', position);
						}
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (let i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		nextToggle() {
			let $switch = $('.js-toggle');

			$switch.on('click', (e) => {
				$(e.currentTarget).toggleClass(a);
				$(e.currentTarget).next('.js-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		easeScroll() {
			$('a[rel="scroll"]').on('click', (event) => {
				if (/#/.test(event.currentTarget.href)) {
					let speed = 1200;
					scrollToObject(event, speed);
					return false;
				}
			});
			function scrollToObject(_self, _speed) {
				let hash = '#' + _self.currentTarget.href.split('#')[1];
				let pos = hash === '#pagetop' ? 0 : $(hash).offset().top;

				if (hash !== '#pagetop') {
					if (KONOIKE.va.window.width < KONOIKE.va.device.sp) {
						pos -= KONOIKE.va.header.sp;
					} else {
						pos -= KONOIKE.va.header.desktop;
					}
				}

				// lazyloadとの併用のための記述
				$.when(
					$('html, body').animate({ scrollTop: pos }, _speed, 'easeOutExpo'),
				).done(() => {
					if (hash !== '#pagetop') {
						let diff = $(hash).offset().top;
						if(KONOIKE.va.window.width < KONOIKE.va.device.sp) {
							diff -= KONOIKE.va.header.sp;
						} else {
							diff -= KONOIKE.va.header.desktop;
						}
						if (diff !== pos) {
							$('html, body').animate({ scrollTop: diff }, 10, 'easeOutExpo');
						}
					}
				});
			}
		},
		easeScrollHash() {
			const hash = location.hash;
			const speed = 1200;
			if (hash) {
				$(window).on('load', () => {
					$('html, body').css('display', 'none');

					setTimeout(() => {
						$('html, body').css('display', 'block');

						let _hash = '#' + hash.split('#')[1];
						let pos = $(_hash).offset().top;

						if (KONOIKE.va.window.width < KONOIKE.va.device.sp) {
							pos -= KONOIKE.va.header.sp;
						} else {
							pos -= KONOIKE.va.header.desktop;
						}
						$('html, body').stop().animate({ scrollTop: pos }, speed, 'easeOutExpo');
					}, 100);
				});
			}
		},
		pageTop() {
			var $pagetop = $('.footer-pagetop');

			$(window).scroll((e) => {
				var $this = $(e.currentTarget);
				var $footer = $('.footer');
				// var footerPos = $footer.offset().top + $footer.height();
				var thisScroll = $this.scrollTop();
				// var pagetopPos = $this.height() + $footer.height() + thisScroll;

				if (thisScroll > '150') {
					$pagetop.addClass(v);
				} else {
					$pagetop.removeClass(v);
				}
			});
		},
		modal() {
			$('.mod-modal').on('click', (e) => {
				let HTML = '<div class="mod-modal-overlay">';
				HTML +=
					'<div class="mod-modal-closeArea"></div>'+
					'<span class="mod-modal-closeBtn"><span></span></span>' +
					`${$(e.currentTarget).find('img').prop('outerHTML')}</div>`;
				$('body').append(HTML);

				const $overlay = $('.mod-modal-overlay');
				$overlay.addClass(a);
				setTimeout(() => {
					$overlay.addClass(v);
					$('.mod-modal-closeArea, .mod-modal-closeBtn').on('click', () => {
						$overlay.removeClass(v);
						setTimeout(() => {
							$overlay.removeClass(a);
							$overlay.remove();
						}, 400);
					});
				});
			});
		},
		lazyload() {
			if ($('.js-lazy-img').length) {
				$('.js-lazy-img').lazyload();
			}
		},
		setImgAttrWidthHeight() {
			const getImg = (_src) => {
				return new Promise((resolve, reject) => {
					const image = new Image();
					image.src = _src;
					image.onload = () => {
						resolve(image);
					}
					image.onerror = (error) => {
						reject(error);
					}
				});
			};

			const imgs = document.getElementsByTagName('img');

			for (const img of imgs) {
				const src = img.getAttribute('src');
				getImg(src).then((res) => {
					if (!img.hasAttribute('width')) {
						img.setAttribute('width', res.width);
					}
					if (!img.hasAttribute('height')) {
						img.setAttribute('height', res.height);
					}
				})
					.catch((error) => {
						console.log(error);
					});
			}
		},
		headerMenu() {
			const $inner = $('.header-inner');
			const $menuBtn = $('.header-menuBtn');
			let scrollTopNow;

			// <SP/TABLET>ヘッダーメニュー開閉
			if ($menuBtn.length) {
				let $menu = $('.header-nav');
				$menuBtn.on('click', (e) => {
					let $this = $menuBtn;

					$this.toggleClass(a);
					$inner.toggleClass(a);
					if ($this.hasClass(a)) {
						// 開く
						$menu.addClass(a);
						fixedOnContainer();
					} else {
						// 閉じる
						$menu.removeClass(a);
						fixedOffContainer();
					}
				});
				$('.header-nav').on('click', (e) => {
					if(!$(e.target).closest('.header-nav-inner').length) {
						// 閉じる
						$menu.removeClass(a);
						$menuBtn.removeClass(a);
						$inner.toggleClass(a);
						fixedOffContainer();
					}
				});

				// メージ内リンクの場合ヘッダーメニュー閉じる
				$('.js-megamenuLink-scroll').on('click', () => {
					$menu.removeClass(a);
					$menuBtn.removeClass(a);
					$inner.toggleClass(a);
					fixedOffContainer();
				});
			}

			const fixedOnContainer = () => {
				scrollTopNow = $(window).scrollTop();
				$('.container').css({
					position: 'fixed',
					width: '100%',
					top: -1 * scrollTopNow,
					left: 0
				});
				$('body').addClass(f);
			};
			const fixedOffContainer = () => {
				$('.container').css({
					position: 'static'
				});
				$('body').removeClass(f);
				$(window).scrollTop(scrollTopNow);
			};

			// カレント
			$('.js-megaMenu-btn').each((idx, ele) => {
				let $href = $(ele).attr('href');
				let $dataName = $(ele).attr('data-name');
				if (KONOIKE.va.pathname.indexOf($href) === 0 || KONOIKE.va.pathname.indexOf($dataName) === 0) {
					$(ele).addClass('is-current');
				}
			});

			// メガメニュー
			if($('.js-megaMenu-btn').length) {
				const $header = $('.header');
				const c = 'is-close';

				// ヘッダーホバー中はベースを白くする
				$header.on('mouseover', (e) => {
					$header.addClass(o);
				});
				$header.on('mouseleave', (e) => {
					if(!$('.js-megaMenu.is-active').length) {
						$header.removeClass(o);
						$('.js-megaMenu-btn').removeClass(a);
					}
				});

				// メガメニュー開く
				$('.js-megaMenu-btn').on('click', (e) => {
					let $this = $(e.currentTarget);
					let $megaMenu = $this.next('.js-megaMenu');
					$('.js-megaMenu-btn').not($this).removeClass(a);
					$('.js-megaMenu').not($megaMenu).removeClass(a);
					// $this.toggleClass(a);
					$megaMenu.toggleClass(a);
					// if($this.hasClass(a)) {
					// 	// $megaMenu.animate({opacity: 1 }, 500);
					// } else {
					// 	// $megaMenu.animate({opacity: 0 }, 500);
					// }
				});
				
				// メガメニュー閉じる
				$('.js-megaMenu-close').on('click', (e) => {
					$('.js-megaMenu').removeClass(a);
					$('.header-megaMenu-inner').addClass(c);
					// $('.js-megaMenu').animate({opacity: 0 }, 500);
					$('.js-megaMenu-btn').removeClass(a);
					$header.removeClass(o);
				});
				$(document).on('click', (e) => {
					if($('.js-megaMenu.is-active').length) {
						if(!$(e.target).closest('.js-megaMenu-btn, .js-megaMenu').length) {
							$('.js-megaMenu').removeClass(a);
							$('.header-megaMenu-inner').addClass(c);
							// $('.js-megaMenu').animate({opacity: 0 }, 500);
							$('.js-megaMenu-btn').removeClass(a);
							$header.removeClass(o);
							// fixedOffContainer();
						}
					}
				});

				// メージ内リンクの場合メガメニュー閉じる
				$('.js-megamenuLink-scroll').on('click', () => {
					$('.js-megaMenu').removeClass(a);
					$('.header-megaMenu-inner').addClass(c);
					$('.js-megaMenu-btn').removeClass(a);
					$header.removeClass(o);
				});
			}
		},
		headerScroll(){
			let $header = $('.header');
			let timer, flag;

			$(window).scroll((e) => {
				let thisScroll = $(e.currentTarget).scrollTop();

				if (timer) clearTimeout(timer);
				if (thisScroll === 0 && flag) {
					$header.removeClass('is-move');
					flag = false;
				} else if (thisScroll > 0 && !flag) {
					$header.addClass('is-move');
					flag = true;
				}
			});
		},
		snsShare(){
			if($('.mod-share').length) {
				let pageUrl = document.URL;
				let shareUrl = "";
				let sharePagetitle = encodeURIComponent(document.title);
				// facebook
				if ($('.mod-share ._facebook').length) {
					shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + pageUrl;
					$('.mod-share ._facebook').attr('href', shareUrl);
				}
				// twitter
				if ($('.mod-share ._twitter').length) {
					shareUrl = 'https://twitter.com/intent/tweet?url='+pageUrl+'&text='+sharePagetitle;
					$('.mod-share ._twitter').attr('href', shareUrl);
				}
				// line
				if ($('.mod-share ._line').length) {
					shareUrl = 'https://timeline.line.me/social-plugin/share?url='+pageUrl+'&text='+sharePagetitle;
					$('.mod-share ._line').attr('href', shareUrl);
				}
			}
		},
		sideNav() {
			if($('.js-sideNav-links').length) {
				$('.js-sideNav-links .__link').each((idx, ele) => {
					if(KONOIKE.va.pathname.indexOf($(ele).attr('href')) === 0) {
						$(ele).addClass(a);
					}
				});
			}
		},
		tabChange(){
			if($('.js-tabChange').length) {
				$('.js-tab-content').eq(0).addClass(a);
				$('.js-tabChange').eq(0).addClass(a);
				$('.js-tabChange-li').eq(0).addClass(a);
				$('.js-tabChange').each((idx, val) => {
					$(val).on('click', () => {
						$('.js-tabChange').removeClass(a);
						$(val).addClass(a);
						$('.js-tab-content').removeClass(a);
						$('.js-tab-content').eq(idx).addClass(a);
						$('.js-tabChange-li').removeClass(a);
						$('.js-tabChange-li').eq(idx).addClass(a);
					});
				});
			}
		},
		siteSearch() {
			if($('.js-siteSearch').length) {
				$('.js-siteSearch-btn').on('click', (e) => {
					$('.js-siteSearch').toggleClass(a);
				});
			}
		},
		marsflag() {
			var el = document.createElement('script');
			if (location.pathname !== '/search/' && location.pathname !== '/en/search/') {
				el.src = '//ce.mf.marsflag.com/latest/js/mf-search.js';
			}
			setTimeout(function () {
				document.body.appendChild(el);
			}, 100);
		},
		loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.modal();
			_this.lazyload();
			_this.setImgAttrWidthHeight();
			_this.headerMenu();
			_this.headerScroll();
			_this.snsShare();
			_this.sideNav();
			_this.tabChange();
			_this.siteSearch();
			_this.marsflag();
		}
	};

	$(() => KONOIKE.localDecision() ? KONOIKE.localLoading() : KONOIKE.loadDelayScript());
})(window.jQuery);
